import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import imageCompression from 'browser-image-compression';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import { uploadFile, getAllCity, createCategory } from '../../helper/backend_helper';
import InfoTooltip from '../InfoTooltip';

const AddCategories = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [city, setCity] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [italianName, setItalianName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [italianDescription, setItalianDescription] = useState('');
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getAllCity();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Check if any field is empty
      if (!formData.profileImage) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Image is required',
        });
        setLoading(false);
        return;
      }
      if (!categoryName) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Category Name is required',
        });
        setLoading(false);
        return;
      }

      if (!italianName) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Name is required',
        });
        setLoading(false);
        return;
      }

      if (!description) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Description is required',
        });
        setLoading(false);
        return;
      }
      if (city.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'City is required',
        });
        setLoading(false);
        return;
      }
      if (!italianDescription) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Description is required',
        });
        setLoading(false);
        return;
      }
      // Prepare headers for multipart form data
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      const originalFile = formData.profileImage;

      // Log original file size
      console.log('Original file size:', (originalFile.size / 1024).toFixed(2), 'KB');

      // Compression options
      const options = {
        maxSizeMB: 0.3, // Compress to a maximum of 0.3 MB
        maxWidthOrHeight: 800, // Restrict dimensions to 800px
        useWebWorker: true, // Use web worker for performance
        initialQuality: 0.6, // Reduce starting quality to 60%
      };

      // Compress image
      const compressedFile = await imageCompression(originalFile, options);

      // Log compressed file size
      console.log('Compressed file size:', (compressedFile.size / 1024).toFixed(2), 'KB');
      const data = new FormData();
      data.append('file', compressedFile);

      const imageUploadResponse = await uploadFile(data, headers);
      console.log(imageUploadResponse?.data?.data?.fileName);

      if (imageUploadResponse.status !== 200) {
        throw new Error('Image upload failed');
      }

      const Categorydata = {
        categoryImage: imageUploadResponse?.data?.data?.fileName,
        categoryName,
        italianName,
        city,
        description,
        italianDescription,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createCategory(Categorydata, Categoryheaders);

      setFormData({
        ...formData,
        profileImage: null,
      });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Category created successfully',
      });
      setCity([]);
      setCategoryName('');
      setDescription('');
      setItalianDescription('');
      setItalianName('');

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Add Category </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add Category</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>City <InfoTooltip title="Cities where this category appears in the guest app. Select all cities it should be shown for." /></FormLabel>
                <Select
                  labelId="demo-multi-select-label"
                  id="demo-multi-select"
                  multiple
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {users?.map((user) => (
                    <MenuItem key={user._id} value={user.name}>
                      <Checkbox checked={city.indexOf(user.name) > -1} />
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Stack>
          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 3 }}>
            <FormLabel sx={{ mb: 1 }}>Category Name <InfoTooltip title="English name of this guest category, e.g. Restaurants or Beaches, shown as a heading in the app." /></FormLabel>
            <TextField
              label="Enter Category Name"
              id="outlined-size-small"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
            />
          </Stack>

          <Stack sx={{ mt: 3 }}>
            <FormLabel sx={{ mb: 1 }}>Category Italian Name <InfoTooltip title="Italian translation of the category name, shown to guests using the app in Italian." /></FormLabel>
            <TextField
              label="Enter Italian Name"
              id="outlined-size-small"
              value={italianName}
              onChange={(e) => setItalianName(e.target.value)}
            />
          </Stack>

          <Stack sx={{ mt: 3 }}>
            <FormLabel sx={{ mb: 1 }}>Description <InfoTooltip title="English description of this category shown to guests under its heading in the app." /></FormLabel>
            <TextField
              label="Enter Description"
              id="outlined-size-small"
              value={description}
              multiline
              rows={4}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Stack>

          <Stack sx={{ mt: 3 }}>
            <FormLabel sx={{ mb: 1 }}>Italian Description <InfoTooltip title="Italian translation of the category description, shown to guests using the app in Italian." /></FormLabel>
            <TextField
              label="Enter Italian Description"
              id="outlined-size-small"
              value={italianDescription}
              multiline
              rows={4}
              onChange={(e) => setItalianDescription(e.target.value)}
            />
          </Stack>

          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack>
              {formData.profileImage && (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="img"
                  style={{ maxWidth: '250px', borderRadius: 20, backgroundColor: '#1E3A5F', padding: 5 }}
                />
              )}
            </Stack>
            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddCategories;
